import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ButtonBase from './ButtonBase';
import classNames from 'classnames';
import {SVGIcon} from '@homeaway/react-svg';
import './ButtonIconBase.less';

class ButtonIcon extends Component {
    static propTypes = {
        ...ButtonBase.propTypes,
        /** SVG markup from @homeaway/svg-defs module. Please reference directly from lib/defs/ */
        svgMarkup: PropTypes.string,
        /** ID name of SVG from an SVG Definition block, the xlink:href of the SVG you want. Used in the 'use' tag to grab it's definition from the SVG Definitions */
        svgId: PropTypes.string,
        /** Flag to determine if this component should also have className .btn-icon-circle */
        circle: PropTypes.bool,
        /** Flag to remove border from ButtonIcon.  Will append className .ButtonIcon--no-border */
        noBorder: PropTypes.bool
    };

    render() {
        const {
            svgMarkup,
            svgId,
            circle,
            className,
            noBorder,
            ...rest
        } = this.props;
        const buttonIconClassName = classNames(
            'btn-icon',
            'ButtonIcon',
            className,
            {
                'btn-icon-circle': circle,
                'ButtonIcon--no-border': noBorder
            }
        );

        let finalIconMarkup;

        if (svgMarkup) {
            finalIconMarkup = (
                <SVGIcon useFill className="flex-center" markup={svgMarkup} />
            );
        } else if (svgId) {
            finalIconMarkup = (
                <span className="flex-center">
                    <SVGIcon useFill id={svgId} />
                </span>
            );
        }

        return (
            <ButtonBase srOnlyLabel className={buttonIconClassName} {...rest}>
                {finalIconMarkup}
                {this.props.children}
            </ButtonBase>
        );
    }
}

export default ButtonIcon;
